module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/43a0f0ae2927a6a173ae5e2aa2478bca.gif";